import { RG_TYPE as o } from "@project-rouge/rg-core";
const t = {
  [o.Core]: { color: "#DADADA", strokeColor: "#DADADA", strokeWidth: 1e-3 },
  [o.Corridor]: { color: "#DADADA", strokeColor: "#DADADA", strokeWidth: 1e-3 },
  [o.Entrance]: { color: "#DADADA", strokeColor: "#DADADA", strokeWidth: 1e-3 },
  [o.TechnicalSpace]: { color: "white", strokeColor: "#DADADA", strokeWidth: 1e-3 },
  [o.Module]: { strokeColor: "#858585", strokeWidth: 1e-3 },
  [o.Floor]: { color: "white", fillOpacity: 1e-3, strokeColor: "#858585", strokeWidth: 0.01 },
  [o.Wall]: { color: "#5F5F5F", strokeColor: "#5F5F5F", strokeWidth: 0.01 },
  [o.Facade]: { color: "#5F5F5F", strokeColor: "#5F5F5F", strokeWidth: 0.01 },
  [o.Opening]: { color: "#5F5F5F", strokeColor: "#5F5F5F", strokeWidth: 0.01 },
  [o.Window]: { color: "white", strokeColor: "#95969a", strokeWidth: 0.01, secondaryStrokeColor: "#95969a", secondaryStrokeWidth: 0.03, drawDimMod: 2 },
  [o.Door]: { color: "white", strokeColor: "#858585", strokeWidth: 0.01 }
};
export {
  t as FloorPlanStyle
};
//# sourceMappingURL=index3.js.map
